import { addHeaderToLayout } from "src/app/ReportGenerator/functions/addHeaderToLayout";
import { addSentimentAnalysisToLayout } from "./addSentimentAnalysisToLayout";
import { addSelectedCommentsToLayout } from "./addSelectedCommentsToLayout";

export const addCommentsAnalysisToLayout = (
  newLayout,
  format,
  campaigns,
  dataAggregation,
) => {
  const aggregation = dataAggregation.commentsAnalysis;

  Object.keys(campaigns).forEach((campaignId) => {
    const {
      sentimentData: { sentimentValues, comments },
    } = campaigns[campaignId];

    if (
      (aggregation && campaignId !== "aggregated") ||
      (!aggregation && campaignId === "aggregated")
    )
      return;

    if (
      !aggregation &&
      campaignId !== "aggregated" &&
      Object.keys(campaigns).length > 1
    ) {
      addHeaderToLayout(
        `comments-analysis-${campaignId}`,
        newLayout,
        format,
        2,
      );
    }

    addSentimentAnalysisToLayout(
      newLayout,
      format,
      campaigns,
      dataAggregation,
      campaignId,
      sentimentValues,
    );
    addSelectedCommentsToLayout(
      newLayout,
      format,
      campaigns,
      dataAggregation,
      campaignId,
      comments,
    );
  });
};
